import {HStack, Show} from 'platform/foundation';

import {useMatch, useParams} from 'react-router-dom';

import {isNotNil} from 'ramda';

import {usePriceReport} from '../../../../../hooks/usePriceReport';
import i18n from '../../../../../i18n/i18n';
import {featureFlags} from '../../../../../utils/featureFlags';
import {getTestId} from '../../../../../utils/getTestId';
import {
  advertisementPath,
  drillDownPath,
  getAdvertisementPath,
  getDrillDownPath,
  getOverviewPath,
  getReasoningPath,
  getStatisticsPath,
  overviewPath,
  reasoningPath,
  statisticsPath,
} from '../../../../../utils/routing';
import {NavigationLink} from './NavigationLink';

interface NavigationProps {
  isLinksDisabled?: boolean;
  shouldScrollActiveLinkIntoView?: boolean;
}

export function Navigation(props: NavigationProps) {
  const {priceReport} = usePriceReport();
  const params = useParams();
  const isOverviewActive = !!useMatch(overviewPath);
  const isStatisticsActive = !!useMatch(statisticsPath);
  const isAdvertisementActive = !!useMatch(advertisementPath);
  const isDrillDownActive = !!useMatch(drillDownPath);
  const isReasoningActive = !!useMatch(reasoningPath);

  return (
    <HStack spacing={6} height={12}>
      <NavigationLink
        isActive={isOverviewActive}
        isDisabled={props.isLinksDisabled}
        to={getOverviewPath(params)}
        shouldScrollIntoView={props.shouldScrollActiveLinkIntoView}
        data-testid={getTestId('header', 'linkToOverview')}
      >
        {i18n.t('page.overview.title')}
      </NavigationLink>
      <NavigationLink
        isActive={isStatisticsActive}
        isDisabled={props.isLinksDisabled}
        to={getStatisticsPath(params)}
        shouldScrollIntoView={props.shouldScrollActiveLinkIntoView}
        data-testid={getTestId('header', 'linkToStatistics')}
      >
        {i18n.t('page.statistics.title')}
      </NavigationLink>
      <NavigationLink
        isActive={isAdvertisementActive}
        isDisabled={props.isLinksDisabled}
        to={getAdvertisementPath(params)}
        shouldScrollIntoView={props.shouldScrollActiveLinkIntoView}
        data-testid={getTestId('header', 'linkToAdvertisement')}
      >
        {i18n.t('page.advertisiments.title')}
      </NavigationLink>
      <NavigationLink
        isActive={isDrillDownActive}
        isDisabled={props.isLinksDisabled}
        to={getDrillDownPath(params)}
        shouldScrollIntoView={props.shouldScrollActiveLinkIntoView}
        data-testid={getTestId('header', 'linkToDrilldown')}
      >
        {i18n.t('page.drillDown.title')}
      </NavigationLink>
      <Show when={isNotNil(priceReport?.arguments)} whenFeatureEnabled={featureFlags.PR_REASONING}>
        <NavigationLink
          isActive={isReasoningActive}
          isDisabled={props.isLinksDisabled}
          to={getReasoningPath(params)}
          shouldScrollIntoView={props.shouldScrollActiveLinkIntoView}
          data-testid={getTestId('header', 'linkToReasoning')}
        >
          {i18n.t('page.reasoning.title')}
        </NavigationLink>
      </Show>
    </HStack>
  );
}
